import { motion } from 'framer-motion';
import { SITE } from '@/constants/testIds';

const items = [
  {
    q: 'We had Window Wizards handle our office glass and the difference was immediate. Danny was professional, clean, no follow-up needed. We work with subcontractors often at ABS, and this is the standard we look for. They’ve earned our repeat business.',
    by: 'Kristen',
    where: 'Associated Building Specialties Inc. · Broomfield, CO',
  },
  {
    q: 'They made our west-facing wall of glass look invisible again. Denver hard water — gone. We won’t use anyone else.',
    by: 'Priya M.',
    where: 'Cherry Creek · Residence',
  },
  {
    q: 'They arrived on time, moved my orchids without me asking, and left the sills cleaner than I did. Craft-level care.',
    by: 'Aline R.',
    where: 'Wash Park · Home',
  },
  {
    q: 'The route crew is invisible — that’s the highest compliment for a service like this. Bi-weekly, always spotless.',
    by: 'Marcus T.',
    where: 'RiNo · Storefront',
  },
];

export function Testimonials() {
  return (
    <section
      data-testid={SITE.testimonialsSection}
      className="relative bg-background py-32 lg:py-44"
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-14">
        <div className="grid grid-cols-12 gap-6 mb-16 items-end">
          <div className="col-span-12 lg:col-span-4">
            <span className="label text-foreground/92">— Denver, on us</span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.9 }}
            className="col-span-12 lg:col-span-8 font-heading font-light uppercase tracking-[-0.02em] text-4xl sm:text-5xl lg:text-6xl leading-[0.95]"
          >
            Words from the
            <span className="font-serif italic lowercase font-light ml-3 lg:ml-4">
              pane
            </span>
            .
          </motion.h2>
        </div>

        <div className="grid grid-cols-12 gap-x-6 gap-y-16">
          {items.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.1 }}
              className={`col-span-12 md:col-span-6 ${
                i % 2 === 1 ? 'md:mt-16' : ''
              }`}
            >
              <blockquote className="font-serif italic font-light text-2xl lg:text-3xl leading-snug tracking-tight text-foreground">
                “{t.q}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-4">
                <span className="w-10 h-px bg-foreground/60" />
                <span className="font-mono text-[12px] tracking-widest text-foreground/95 uppercase">
                  {t.by} — {t.where}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
